module.exports = __webpack_public_path__ + "static/img/10.899c783c.png";